import React from 'react'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious
} from '@/modules/components/ui/carousel'
import { TJournalData } from '~shared/api/single-journal-data/types'
import { JournalCard } from '~shared/components/journal-card'

export const JournalSimilarArticle = ({
  journal
}: {
  journal: TJournalData
}) => {
  return (
    <div className='max-w-full'>
      <h2 className='typo-section-heading text-center'>Похожие статьи</h2>
      <Carousel
        opts={{
          align: 'start',
          loop: true,
          skipSnaps: true
        }}
        className='mt-[16px] md:mt-[24px] lg:mt-[40px] xl:mt-[60px] w-full overflow-hidden'
        aria-label='Журнал'>
        <CarouselContent>
          {journal?.linkedJournal?.map(journal => (
            <CarouselItem
              key={journal.id}
              className='basis-full md:basis-1/2 select-none'>
              <JournalCard model={journal?.journal} className='h-full' />
            </CarouselItem>
          ))}
        </CarouselContent>
        <div className='flex gap-4 mx-auto w-fit mt-[30px] md:mt-[40px] xl:mt-[60px]'>
          <CarouselPrevious size='lg' />
          <CarouselNext size='lg' />
        </div>
      </Carousel>
    </div>
  )
}
